import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, Camera, CheckCircle, Truck, FileText } from 'lucide-react';

const steps = [
    {
        title: "Reporta un problema",
        description: "Toma una foto, georreferencia y envía. Así de simple.",
        icon: <Camera size={48} />,
        color: "bg-red-100 text-red-600",
        image: "/luminaria.jpg"
    },
    {
        title: "Gestión del Ticket",
        description: "El sistema clasifica y avisa al departamento correspondiente.",
        icon: <FileText size={48} />,
        color: "bg-blue-100 text-blue-600",
        image: "/feature-automation.png"
    },
    {
        title: "Despacho Inmediato",
        description: "La cuadrilla o empresa externa recibe la orden de trabajo.",
        icon: <Truck size={48} />,
        color: "bg-orange-100 text-orange-600",
        image: "/fixing_light.png"
    },
    {
        title: "Problema Resuelto",
        description: "Se cierra el ticket con evidencia fotográfica obligatoria.",
        icon: <CheckCircle size={48} />,
        color: "bg-green-100 text-green-600",
        image: "/luminaria_encendida.png"
    }
];

const ProcessCarousel = () => {
    const [currentStep, setCurrentStep] = useState(0);

    const nextStep = () => setCurrentStep((prev) => (prev + 1) % steps.length);
    const prevStep = () => setCurrentStep((prev) => (prev - 1 + steps.length) % steps.length);

    // Auto-advance
    useEffect(() => {
        const timer = setInterval(nextStep, 5000);
        return () => clearInterval(timer);
    }, []);

    return (
        <div className="bg-slate-900 rounded-[2.5rem] shadow-xl border border-slate-100 relative overflow-hidden h-full flex flex-col justify-center group">

            {/* Background Image with Transition */}
            {steps.map((step, idx) => (
                <div
                    key={idx}
                    className={`absolute inset-0 transition-opacity duration-700 ease-in-out ${idx === currentStep ? 'opacity-100' : 'opacity-0'}`}
                >
                    <img
                        src={step.image}
                        alt={step.title}
                        className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-black/30"></div>
                </div>
            ))}

            {/* Navigation Buttons */}
            <div className="absolute top-6 right-6 flex gap-2 z-20">
                <button onClick={prevStep} className="p-2 rounded-full bg-white/20 hover:bg-white/30 backdrop-blur-md text-white transition border border-white/10">
                    <ChevronLeft size={20} />
                </button>
                <button onClick={nextStep} className="p-2 rounded-full bg-white/20 hover:bg-white/30 backdrop-blur-md text-white transition border border-white/10">
                    <ChevronRight size={20} />
                </button>
            </div>

            {/* Content */}
            <div className="relative z-10 p-8 md:p-12 transition-all duration-500 ease-in-out transform">
                <div className="flex flex-col items-center text-center space-y-6">
                    <div className={`w-24 h-24 rounded-3xl flex items-center justify-center ${steps[currentStep].color} shadow-2xl mb-4 border-4 border-white/20 backdrop-blur-sm`}>
                        {steps[currentStep].icon}
                    </div>
                    <h3 className="text-4xl font-black text-white drop-shadow-lg tracking-tight">
                        {steps[currentStep].title}
                    </h3>
                    <p className="text-xl text-slate-100 font-medium max-w-md drop-shadow-md leading-relaxed">
                        {steps[currentStep].description}
                    </p>
                </div>
            </div>

            {/* Pagination Dots */}
            <div className="absolute bottom-8 left-0 right-0 flex justify-center gap-2 z-20">
                {steps.map((_, idx) => (
                    <div
                        key={idx}
                        className={`h-2 rounded-full transition-all duration-300 shadow-sm ${idx === currentStep ? 'w-8 bg-white' : 'w-2 bg-white/40'}`}
                    />
                ))}
            </div>
        </div>
    );
};

export default ProcessCarousel;
